import { CognitoUserPool } from "amazon-cognito-identity-js";
import config from "../config";
import AWS from "aws-sdk";
import sigV4Client from "./sigV4Client";

export async function authUser() {
  if (
    AWS.config.credentials &&
    Date.now() < AWS.config.credentials.expireTime - 60000
  ) {
    return true;
  }

  const currentUser = getCurrentUser();

  if (currentUser === null) {
    return false;
  }

  const userToken = await getUserToken(currentUser);

  await getAwsCredentials(userToken);

  return true;
}

function getUserToken(currentUser) {
  return new Promise((resolve, reject) => {
    currentUser.getSession(function(err, session) {
      if (err) {
        reject(err);
        return;
      }
      resolve(session.getIdToken().getJwtToken());
    });
  });
}

function getCurrentUser() {
  const userPool = new CognitoUserPool({
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.APP_CLIENT_ID
  });
  return userPool.getCurrentUser();
}

function getAwsCredentials(userToken) {
  const authenticator = `cognito-idp.${config.cognito
    .REGION}.amazonaws.com/${config.cognito.USER_POOL_ID}`;

  AWS.config.update({ region: config.cognito.REGION });

  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: config.cognito.IDENTITY_POOL_ID,
    Logins: {
      [authenticator]: userToken
    }
  });

  return AWS.config.credentials.getPromise();
}

export function   signOutUser() {
  const currentUser = getCurrentUser();

  if (currentUser !== null) {
    currentUser.signOut();
  }
}

export async function invokeApig({
  path,
  method = "",
  headers = {
  },
  queryParams = {},
  body
}) {
  if (!await authUser()) {
    throw new Error("User is not logged in");
  }

  const signedRequest = sigV4Client
    .newClient({
      accessKey: AWS.config.credentials.accessKeyId,
      secretKey: AWS.config.credentials.secretAccessKey,
      sessionToken: AWS.config.credentials.sessionToken,
    
      region: config.apiGateway.REGION,
      endpoint: config.apiGateway.PRODURL
    })
    .signRequest({
      method,
      path,
      headers,
      queryParams,
      body
    });

  body = body ? JSON.stringify(body) : body;
  headers = signedRequest.headers;
  
  const results = await fetch(signedRequest.url, {
    method,
    headers,
    body
  });

  if (results.status !== 200) {
    throw new Error(await results.text());
  }

  return results.json();
}

//Add video file to S3
export async function s3Upload(file) {

  if (!await authUser()) {
    throw new Error("User is not logged in");
  }
  const s3Video = new AWS.S3({
    params: {
      Bucket: config.s3.VIDEO_BUCKET
    }
  });
  const filename = `${file.name}`;

  return s3Video
    .upload({
      Key: filename,
      Body: file,
      ContentType: file.type,
      ACL: "public-read"
    })
    .promise();
}

//Delete video file from video S3
export async function s3Delete(file) {

  if (!await authUser()) {
    throw new Error("User is not logged in");
  }
  const s3Video = new AWS.S3({
    params: {
      Bucket: config.s3.VIDEO_BUCKET
    }
  });


  return s3Video
    .deleteObject({
      Key: file,
    })
    .promise();
}

//Add video thumbnail to S3
export async function s3ThumbnailUpload(file) {

  if (!await authUser()) {
    throw new Error("User is not logged in");
  }
  const s3VideoThumbnail = new AWS.S3({
    params: {
      Bucket: config.s3.VIDEO_THUMBNAILS_BUCKET
    }
  });
  const filename = `${file.name}`;

  return s3VideoThumbnail
    .upload({
      Key: filename,
      Body: file,
      ContentType: file.type,
      ACL: "public-read"
    })
    .promise();
}

//Delete Video Thumbnail from S3
export async function s3DeleteThumbnail(file) {

  if (!await authUser()) {
    throw new Error("User is not logged in");
  }
  const s3Thumbnail = new AWS.S3({
    params: {
      Bucket: config.s3.VIDEO_THUMBNAILS_BUCKET
    }
  });


  return s3Thumbnail
    .deleteObject({
      Key: file,
    })
    .promise();
}